module.exports = __webpack_public_path__ + "img/lb2.2e27fc1f.jpg";